import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAllSectors = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 10C18 9 17 8 15 8C14.6978 8 14.355 8 14.0002 8C12.3434 8 11 6.65685 11 5V2M18 21H21V12H18V16.5M18 21V16.5M18 21H3V17L6.5 14L10.5 16.5L14.5 14L18 16.5M21 10C21 4 17 4 17 4C17 4 21 4.5 21 2",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAllSectors;
